import { createQueryKeys } from '@lukemorales/query-key-factory';
import { getLikedSnapsCountService } from '@musinsa/services-curator';

export const snapLikeFactory = createQueryKeys('snap-like', {
  /** 큐레이션 단위 snapIds 좋아요 카운트. snapIds는 정렬 후 join하여 키 안정화 */
  likedCount: (snapIds: string[]) => ({
    queryKey: [{ ids: [...snapIds].sort().join(',') }],
    queryFn: () =>
      snapIds.length === 0 ? Promise.resolve({}) : getLikedSnapsCountService({ ids: snapIds }),
  }),
});
